import { Incidente } from "@/domain";
import { Header } from "@/presentation/components";
import { Detail, DetailSection } from "@/presentation/components/DetailCard/DetailCard";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { BottomAppBar } from "@/presentation/components/layout/BottomAppBar";
import { useAuthContext } from "@/presentation/context";
import { useIncidente } from "@/presentation/hooks/useIncidente";
import { routes } from "@/presentation/router";
import { formatPriority, formatState } from "@/shared";
import { formatSmartDateTime } from "@/shared/utils/dateFormaters";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function IncidenteDetailPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setIsDrawerOpen(false);
    navigate(routes.login, { replace: true });
  };
  const { id } = useParams();
  console.log('ID PARAMS', id);

  const {
    incidente,
    loadById,
  } = useIncidente();

  useEffect(() => {
    if (id) {
      loadById(Number(id));
    }
  }, [id, loadById]);
  console.log(incidente)

  if (!incidente) {
    return <>Cargando...</>;
  }
  const incidenteDetailSections: DetailSection<Incidente>[] = [
    {
      title: "Información General",
      fields: [
        {
          label: "Número de Incidente",
          key: "id"
        },
        {
          label: "Equipo",
          key: "equipo",
          onSelect: () => {
            navigate(`/equipo/${incidente.id_equipo}`);
          }

        },
        {
          label: "Estado",
          key: "estado",
          render: (value) => formatState(value as number)

        },
        {
          label: "Prioridad",
          key: "prioridad",
          render: (value) => formatPriority(value as number)
        },
        {
          label: "Tipo",
          key: "tipo",
        },
        {
          label: "Iniciado",
          key: "iniciado",
          render: (value) =>
            formatSmartDateTime(value as Date)
        },
        {
          label: "Creador",
          key: "creador"
        },
        {
          label: "Ultima Actualización",
          key: "ult_actualizacion",
          render: (value) =>
            formatSmartDateTime(value as Date)
        },

      ],
    },
    {
      title: "Contacto",
      fields: [
        {
          label: "Contacto",
          key: "contacto",
        },
        {
          label: "Teléfono",
          key: "telefono",
        },
        {
          label: "Responsable",
          key: "responsable",
        },
        {
          label: "Contador",
          key: "contador",
        },
      ],
    },
  ];





  return (
    <div>
      <Header
        title="Detalle del Incidente"
        onMenuClick={handleOpenDrawer}
      />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={handleCloseDrawer}
        onLogout={handleLogout}
      />
      <Detail
        data={incidente}
        sections={incidenteDetailSections}
      />




      <BottomAppBar
        items={[
          ...(incidente.estado == 1
            ? [
              {
                label: 'Editar',
                onClick: () =>
                  navigate(`/incidentes/formulario/${id}`),
                icon: undefined,
              },
            ]
            : []),

          {
            label: 'Acciones',
            onClick: () => {
              navigate(`/acciones/${id}`, {
                state: {
                  estado: incidente.estado,
                },
              });
            },
            icon: undefined,
          },
          {
            label: 'Repuestos',
            onClick: () => { navigate(`/repuestos/${id}`) },
            icon: undefined,
          },
        ]}
      />
    </div>
  );
}